"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _components = require("@engaging-tech/components");
var _routing = require("@engaging-tech/routing");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
var _routeHighlightChecker = _interopRequireDefault(require("../../utils/routeHighlightChecker"));
var _SingleNavItem = _interopRequireDefault(require("./SingleNavItem"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var FlipIcon = (0, _styledComponents["default"])(_components.Icon).withConfig({
  displayName: "ExpandableNavItem__FlipIcon",
  componentId: "sc-2xyaak-0"
})(["transform:", ";transition:0.18s;&:hover{cursor:pointer;}"], function (_ref) {
  var isFlipped = _ref.isFlipped;
  return isFlipped ? "rotate(180deg)" : "rotate(0deg)";
});
var LinkWrapper = function LinkWrapper(_ref2) {
  var route = _ref2.route,
    children = _ref2.children;
  if (route.path) {
    return /*#__PURE__*/_react["default"].createElement(_routing.Link, (0, _extends2["default"])({
      to: route.path,
      external: route.path.includes("#"),
      style: {
        width: "100%"
      }
    }, route.linkProps), children);
  }
  return children;
};

/**
 * A nav item that can be expanded and collapsed. When expanded,
 * the item's child routes are visible. This component is **mobile-only**.
 * @param {object} props React components passed in props
 * @param {object} props.route The route to display an expandable item
 * for.
 * @param {function} props.onNavigate An event to be fired when the
 * nav item is clicked.
 * @param {array} props.childRoutes The child routes to display
 * @package
 */
var ExpandableNavItem = function ExpandableNavItem(_ref3) {
  var route = _ref3.route,
    childRoutes = _ref3.childRoutes,
    onNavigate = _ref3.onNavigate;
  var _useNavContext = (0, _useNavContext2["default"])(),
    fontFamilies = _useNavContext.fontFamilies,
    navbarItemColor = _useNavContext.navbarItemColor;
  var router = (0, _routing.useRouter)();
  var _useState = (0, _react.useState)(router.isMatch(route.path)),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var shouldHighlight = (0, _routeHighlightChecker["default"])(route);
  var toggleOpen = function toggleOpen() {
    return setIsOpen(!isOpen);
  };
  var expandVariants = {
    hidden: function hidden(childrenAmount) {
      return {
        height: 0,
        transition: {
          ease: "easeInOut",
          duration: childrenAmount * 0.08,
          staggerChildren: 0.08,
          staggerDirection: -1
        },
        transitionEnd: {
          display: "none"
        }
      };
    },
    visible: function visible(childrenAmount) {
      return {
        height: "auto",
        transition: {
          ease: "easeInOut",
          duration: childrenAmount * 0.08,
          staggerChildren: childrenAmount * 0.01
        },
        transitionEnd: {
          display: "flex"
        }
      };
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    height: "50px",
    px: 3,
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(LinkWrapper, {
    route: route
  }, /*#__PURE__*/_react["default"].createElement(_components.Box, {
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    fontSize: 18,
    fontWeight: 700,
    fontFamily: shouldHighlight ? fontFamilies.selected : fontFamilies.unSelected,
    color: shouldHighlight ? navbarItemColor.selected : navbarItemColor.unSelected
  }, route.description))), /*#__PURE__*/_react["default"].createElement(FlipIcon, {
    name: "expand_more",
    isFlipped: isOpen,
    onClick: toggleOpen
  })), /*#__PURE__*/_react["default"].createElement(_components.MotionFlex, {
    variants: expandVariants,
    initial: "hidden",
    animate: isOpen ? "visible" : "hidden",
    flexDirection: "column",
    custom: childRoutes.length
  }, childRoutes.map(function (childRoute, i) {
    return /*#__PURE__*/_react["default"].createElement(_SingleNavItem["default"], {
      key: childRoute.description,
      route: childRoute,
      onNavigate: onNavigate,
      i: i
      // @ts-ignore
      ,
      pl: 5,
      fontSize: 16,
      mb: 3,
      mt: 3
    });
  })));
};
var _default = exports["default"] = ExpandableNavItem;